/**
 * Каталог IT-профессий для поля job_title / должности в профиле.
 * Должен совпадать с server/config/jobTitles.js
 */

export const JOB_TITLES: readonly string[] = [
  // Software engineering
  'Software Engineer',
  'Backend Developer',
  'Frontend Developer',
  'Full Stack Developer',
  'Mobile Developer',
  'Embedded Developer',
  'Game Developer',
  'Platform Engineer',
  'Tech Lead',
  'Solution Architect',
  'System Architect',

  // Languages / stacks
  'Python Developer',
  'Java Developer',
  'JavaScript Developer',
  'TypeScript Developer',
  'C++ Developer',
  'C# Developer',
  'Go Developer',
  'Rust Developer',
  'Kotlin Developer',
  'Swift Developer',

  // Data & analytics
  'Data Scientist',
  'Data Analyst',
  'Data Engineer',
  'Analytics Engineer',
  'BI Developer',
  'ETL Developer',
  'Business Analyst',
  'Systems Analyst',
  'Quantitative Analyst',

  // ML / AI
  'ML Engineer',
  'AI Engineer',
  'MLOps Engineer',
  'NLP Engineer',
  'Computer Vision Engineer',
  'Research Engineer',
  'Research Scientist',

  // Algorithms / competitive
  'Algorithm Engineer',
  'Competitive Programmer',
  'Scientific Programmer',
  'Bioinformatics Engineer',
  'Robotics Engineer',

  // Databases / SQL
  'SQL Developer',
  'Database Developer',
  'Database Administrator',

  // Infra / cloud / security / QA
  'DevOps Engineer',
  'Site Reliability Engineer',
  'Cloud Engineer',
  'Security Engineer',
  'QA Engineer',
  'Test Automation Engineer',

  // Product / other tech
  'Product Analyst',
  'Blockchain Developer',
  'Firmware Engineer',

  // Early career
  'Software Engineering Intern',
  'Data Science Intern',
  'ML Intern',
  'Teaching Assistant',
  'Student',
].slice().sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

const ALLOWED = new Set(JOB_TITLES.map((t) => t.toLowerCase()));

export function isAllowedJobTitle(title: string): boolean {
  return ALLOWED.has(title.trim().toLowerCase());
}

export function normalizeJobTitle(title: string): string | null {
  const raw = title.trim();
  if (!raw) return null;
  const found = JOB_TITLES.find((t) => t.toLowerCase() === raw.toLowerCase());
  return found || null;
}

/**
 * Подсказки по вводу; alreadySelected исключаются.
 */
export function getJobTitleSuggestions(
  query: string,
  alreadySelected: string[] = [],
  limit = 10,
): string[] {
  const q = query.trim().toLowerCase();
  const selected = new Set(alreadySelected.map((s) => s.trim().toLowerCase()));
  const startsWith: string[] = [];
  const includes: string[] = [];

  for (const title of JOB_TITLES) {
    const n = title.toLowerCase();
    if (selected.has(n)) continue;
    if (!q) {
      startsWith.push(title);
      continue;
    }
    if (n.startsWith(q)) startsWith.push(title);
    else if (n.includes(q)) includes.push(title);
  }

  return [...startsWith, ...includes].slice(0, limit);
}
